module.exports = __webpack_public_path__ + "static/img/ipad@3x.8f71298.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aerospace/ipad@3x.png
// module id = 4tLE
// module chunks = 1